import SelectorEngine from '../../utils/dom/selector-engine';
import BaseComponent from '../BaseComponent';
import EventHandler from '../../utils/dom/event-handler';
const NAME = 'Tooltip';

class Tooltip extends BaseComponent {

	constructor(element) {
		super(element);
		this._element = element;
		this.trigger = SelectorEngine.findOne('.js-lta-tooltip__trigger', element);
		this.init();
	}

	static get NAME() {
		return NAME;
	}

	init() {
		EventHandler.on(this.trigger, 'click', (e) => {
			this.clickHandler(e);
		});
		EventHandler.on(this.trigger, 'keypress', (e) => {
			if (e.keyCode == 13) this.clickHandler(e);
		});
	}

	clickHandler() {
		const content = this.trigger.nextElementSibling;
		content.classList.toggle('is-visible');
	}

}

export default Tooltip;
